import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

// Async thunks
export const fetchUnknownList = createAsyncThunk(
  'unknown/fetchList',
  async (params, { rejectWithValue }) => {
    try {
      return await api.getUnknownList(params);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchUnknownLogs = createAsyncThunk(
  'unknown/fetchLogs',
  async ({ id, params }, { rejectWithValue }) => {
    try {
      return await api.getUnknownLogs(id, params);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchUnknownPhotos = createAsyncThunk(
  'unknown/fetchPhotos',
  async (id, { rejectWithValue }) => {
    try {
      return await api.getUnknownPhotos(id);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const promoteUnknown = createAsyncThunk(
  'unknown/promote',
  async (data, { rejectWithValue }) => {
    try {
      return await api.promoteUnknown(data);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const unknownSlice = createSlice({
  name: 'unknown',
  initialState: {
    list: [],
    total: 0,
    selectedUnknown: null,
    logs: [],
    photos: [],
    loading: false,
    error: null,
    pagination: {
      current: 1,
      pageSize: 12,
      total: 0,
    },
  },
  reducers: {
    setSelectedUnknown: (state, action) => {
      state.selectedUnknown = action.payload;
    },
    clearSelectedUnknown: (state) => {
      state.selectedUnknown = null;
      state.logs = [];
      state.photos = [];
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch list
    builder
      .addCase(fetchUnknownList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUnknownList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.total = action.payload.total;
        state.pagination.total = action.payload.total;
      })
      .addCase(fetchUnknownList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Fetch logs
    builder
      .addCase(fetchUnknownLogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUnknownLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = action.payload.data;
      })
      .addCase(fetchUnknownLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Fetch photos
    builder
      .addCase(fetchUnknownPhotos.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUnknownPhotos.fulfilled, (state, action) => {
        state.loading = false;
        state.photos = action.payload.images;
      })
      .addCase(fetchUnknownPhotos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Promote unknown
    builder
      .addCase(promoteUnknown.pending, (state) => {
        state.loading = true;
      })
      .addCase(promoteUnknown.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(promoteUnknown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSelectedUnknown, clearSelectedUnknown, setPagination, clearError } =
  unknownSlice.actions;

export default unknownSlice.reducer;
